import { post, get } from "../services/http";
import environment from '../environment';
const actions = {
    addKeepAlivePage({ commit }, name) {
        commit('ADD_KEEP_ALVE', name)
    },
    delKeepAlivePage({ commit }, name) {
        commit('DEL_KEEP_ALVE', name)
    },
}


export default actions